export default {
  placesAndDirections: {
    isochrones: 'Izocronii',
    noPlaceFound: 'Nu s-a găsit niciun loc cu conținutul introdus',
    routeReady: 'Ruta pregătită',
    useLocation: 'GPS',
    addPlaceInput: 'Adăugați locul',
    clearRoute: 'Rută liberă',
    reverseRoute: 'Inversați',
    calculatingRoute: 'Calcularea rutei...',
    yourLocation: 'Locația dumneavoastră',
    place: 'loc',
    notRouteFound: 'Nu a fost posibil să se găsească o rută care să lege locurile cu profilul selectat',
    notRouteFoundWithFilters: 'Nu a fost posibil să se găsească o rută care să conecteze locurile cu profilul și filtrele selectate',
    orderByClosestPlaces: 'Comandați prin locuri mai apropiate de locația dumneavoastră',
    expandAltitudeChart: 'Extindeți graficul',
    errorRenderingContentUploaded: 'Eroare la redarea conținutului încărcat. Verificați formatul și conținutul fișierului',
    roundTrip: 'Călătorie dus-întors',
    notPossibleToCalculateRoute: 'O rută nu a putut fi calculată folosind unul dintre locurile selectate',
    apiError: {
      2000: 'Nu se poate analiza cererea JSON',
      2001: 'Parametrul necesar lipsește',
      2002: 'Format de parametru invalid',
      2006: 'Imposibilitatea de a analiza cererea către gestionarul de export',
      2007: 'Format de export neacceptat',
      2008: 'Element gol',
      2009: 'Imposibilitatea de a găsi un traseu adecvat pentru locurile și criteriile specificate. Poate că profilul specificat nu este acceptat în această zonă/regiune cu filtrul aplicat(e).',
      2011: 'Atunci când se utilizează opțiunea de trasee alternative, nu este posibilă definirea de opriri pe traseu',
      2003: 'Parametrii rutei depășesc una sau mai multe limite. Vă rugăm să rețineți că unele variabile de evitare au limite, cum ar fi lungimea traseului și suprafața unui poligon de evitare care nu trebuie să depășească 20000 de kilometri pătrați.',
      2004: 'Parametrii rutei depășesc una sau mai multe limite. Rețineți că distanța aproximativă a traseului nu trebuie să fie mai mare de 6000 km. În cazul în care se utilizează anumite opțiuni de traseu sau anumite opțiuni de evitare, distanța aproximativă a traseului nu trebuie să fie mai mare de 150 km.',
      2010: 'Nu a fost posibil să se găsească un punct potrivit care să facă parte din traseu. Poate că unul dintre punctele selectate nu poate fi trasat sau profilul selectat nu este acceptat în această regiune',
      2012: 'A fost specificat un parametru invalid. Asigurați-vă că URL-ul este corect',
      2099: 'Nu se poate calcula o rută care să conecteze locurile selectate',
    },
    genericErrorMsg: 'Nu a fost posibil să se calculeze ruta',
    reorder: 'Reordonare',
    timeoutError: 'Solicitarea a durat prea mult și a fost anulată. Încercați distanțe mai scurte.'
  }
}
